<form fxLayout="column" fxLayoutGap="20px" [formGroup]="datiFirmaForm" #form>

  <!-- <ng-container *ngIf="dataService.prodotto?.tipo_utenza == 'DOM' && !['TUTELA', 'VULNERABILI', 'PLACET'].includes(dataService.prodotto!.natura)"> -->
  <ng-container *ngIf="false">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h2 class="divider-title">
          Scegli la tua operazione a premi gratuita o la tua promozione
          {{dataService.prodotto?.cod_tipo_fornitura_id == 'EE/GAS' ? 'per energia elettrica':''}}
        </h2>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px">

      <div fxLayout="column" fxFlex="auto" fxLayoutGap="20px" class="premi">
        <mat-radio-group fxLayout="column" fxLayoutGap="20px" formControlName="premi" [disabled]="premioConfermato">
          <mat-radio-button value="4">
            <div fxLayout="row" fxLayoutAlign="start center">
              <img src="../../../assets/imgs/logo_cremonese.png" alt="cremonese-calcio-logo" class="logo-cremonese">
              <label>Operazione a premi - ASPM tifa Cremo</label>
            </div>
            <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
              <button mat-button color="accent" (click)="downloadPrivacy(4)">
                Privacy
                <mat-icon>download</mat-icon>
              </button>
              <button mat-button color="accent" (click)="downloadRegolamento(4)">
                Regolamento
                <mat-icon>download</mat-icon>
              </button>
            </div>
          </mat-radio-button>
          <mat-radio-button value="1">
            <div fxLayout="row">
              <mat-icon svgIcon="amazon"></mat-icon>
              <label>Operazione a premi - ASPM ti regala Amazon</label>
            </div>
            <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
              <button mat-button color="accent" (click)="downloadPrivacy(1)">
                Privacy
                <mat-icon>download</mat-icon>
              </button>
              <button mat-button color="accent" (click)="downloadRegolamento(1)">
                Regolamento
                <mat-icon>download</mat-icon>
              </button>
            </div>
          </mat-radio-button>
          <mat-radio-button value="2">
            <div fxLayout="row">
              <img src="../../../assets/imgs/wishlist.png" alt="wishlist-logo" class="logo-wishlist">
              <label>Operazione a premi - ASPM dà energia alle tue passioni</label>
            </div>
            <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
              <button mat-button color="accent" (click)="downloadPrivacy(2)">
                Privacy
                <mat-icon>download</mat-icon>
              </button>
              <button mat-button color="accent" (click)="downloadRegolamento(2)">
                Regolamento
                <mat-icon>download</mat-icon>
              </button>
            </div>
          </mat-radio-button>
          <mat-radio-button value="3" *ngIf="dataService.user != 2">
            <div fxLayout="row" fxLayoutAlign="start center">
              <img src="../../../assets/imgs/alca.png" alt="alca-logo" class="logo-alca">
              <label>Operazione a premi - ASPM dà energia alle tue passioni</label>
            </div>
            <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
              <button mat-button color="accent" (click)="downloadPrivacy(3)">
                Privacy
                <mat-icon>download</mat-icon>
              </button>
              <button mat-button color="accent" (click)="downloadRegolamento(3)">
                Regolamento
                <mat-icon>download</mat-icon>
              </button>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div fxLayout="column" fxFlex="40" fxLayoutGap="20px">
        <div fxLayout="column" class="lista-premi" *ngIf="premi.value == '0' && !premioConfermato">
          <mat-radio-group formControlName="mondadori" fxFlexFill>
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree" fxFlexFill>
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle fxFlexFill>
                <li fxFlexFill class="li-tree-node">
                  <mat-card fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutAlign.md="center center" fxLayoutAlign.sm="center center" fxFlexFill>
                    <mat-card-header>
                      <mat-card-title>
                        <mat-radio-button [value]="node.nome">{{node.nome}}</mat-radio-button>
                      </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      <img [src]="node.img" [alt]="node.nome" width="100px" />
                    </mat-card-content>
                  </mat-card>
                </li>
              </mat-tree-node>
              <!-- This is the tree node template for expandable nodes -->
              <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                <li class="li-nested-node">
                  <div fxLayoutAlign="start center">
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.nome">
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                      </mat-icon>
                    </button>
                    {{node.nome}} {{node.id}}
                  </div>
                  <ul [class.tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </ul>
                </li>
              </mat-nested-tree-node>
            </mat-tree>
          </mat-radio-group>
        </div>

        <div fxLayout="column" class="lista-premi" *ngIf="premi.value == '2' && !premioConfermato">
          <mat-radio-group fxFlexFill formControlName="wishlist">
            <mat-tree [dataSource]="dataSourceWish" [treeControl]="treeControlWish" class="example-tree" fxFlexFill>
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle fxFlexFill>
                <li fxFlexFill class="li-tree-node">
                  <mat-card fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutAlign.md="center center" fxLayoutAlign.sm="center center" fxFlexFill>
                    <mat-card-header>
                      <mat-card-title>
                        <mat-radio-button [value]="node.nome">{{node.nome}}</mat-radio-button>
                      </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      <img [src]="node.img" [alt]="node.nome" width="100px" />
                    </mat-card-content>
                  </mat-card>
                </li>
              </mat-tree-node>
              <!-- This is the tree node template for expandable nodes -->
              <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                <li class="li-nested-node">
                  <div fxLayoutAlign="start center">
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.nome">
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControlWish.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                      </mat-icon>
                    </button>
                    {{node.nome}} {{node.id}}
                  </div>
                  <ul [class.tree-invisible]="!treeControlWish.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </ul>
                </li>
              </mat-nested-tree-node>
            </mat-tree>
          </mat-radio-group>
        </div>

        <div *ngIf="premi.value != null && !premioConfermato">
          <button [disabled]="setConfermaPremiDisabled()" color="accent" mat-flat-button (click)="confermaPremio(true)" fxFlexFill fxLayoutAlign="center center">
            Conferma<mat-icon aria-label="label">done</mat-icon>
          </button>
        </div>

        <div *ngIf="premioConfermato && premi.value != null">
          <button color="accent" mat-flat-button (click)="confermaPremio(false)" fxFlexFill fxLayoutAlign="center center">
            Modifica<mat-icon aria-label="label">edit</mat-icon>
          </button>
        </div>

        <mat-error *ngIf="premi.hasError('unchecked')">* Confermare il premio per continuare</mat-error>

      </div>

    </div>

    <ng-container *ngIf="dataService.prodotto?.cod_tipo_fornitura_id == 'EE/GAS'">
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
        <div>
          <h2 class="divider-title">
            Scegli la tua operazione a premi gratuita o la tua promozione per gas naturale
            <!-- <mat-icon color="primary"
              matTooltip="Volendo sottoscrivere un contratto dual puoi selezionare un altro premio anche differente dal precedente"
              matTooltipPosition="above">
              help</mat-icon> -->
          </h2>
        </div>
        <mat-divider fxFlex="auto"></mat-divider>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <i>Volendo sottoscrivere un contratto dual puoi selezionare un altro premio anche differente dal precedente</i>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px">

        <div fxLayout="column" fxFlex="auto" fxLayoutGap="20px" class="premi">
          <mat-radio-group fxLayout="column" fxLayoutGap="20px" formControlName="premiG" [disabled]="premioConfermatoG">
            <mat-radio-button [disabled]="dataService.user != 2" value="0" fxLayout="row wrap" class="mondadori-radio">
              <div fxLayout="row">
                <mat-icon svgIcon="mondadori"></mat-icon>
                <label>Abbonamento annuale a periodico Mondadori</label>
              </div>
              <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
                <button mat-button color="accent" (click)="downloadPrivacy(0)">
                  Privacy
                  <mat-icon>download</mat-icon>
                </button>
                <button mat-button color="accent" (click)="downloadRegolamento(0)">
                  Regolamento
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </mat-radio-button>
            <mat-radio-button value="4">
              <div fxLayout="row" fxLayoutAlign="start center">
                <img src="../../../assets/imgs/logo_cremonese.png" alt="cremonese-calcio-logo" class="logo-cremonese">
                <label>Operazione a premi - ASPM tifa Cremo</label>
              </div>
              <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
                <button mat-button color="accent" (click)="downloadPrivacy(4)">
                  Privacy
                  <mat-icon>download</mat-icon>
                </button>
                <button mat-button color="accent" (click)="downloadRegolamento(4)">
                  Regolamento
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </mat-radio-button>
            <mat-radio-button value="1">
              <div fxLayout="row">
                <mat-icon svgIcon="amazon"></mat-icon>
                <label>Operazione a premi - ASPM ti regala Amazon</label>
              </div>
              <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
                <button mat-button color="accent" (click)="downloadPrivacy(1)">
                  Privacy
                  <mat-icon>download</mat-icon>
                </button>
                <button mat-button color="accent" (click)="downloadRegolamento(1)">
                  Regolamento
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </mat-radio-button>
            <mat-radio-button value="2">
              <div fxLayout="row">
                <img src="../../../assets/imgs/wishlist.png" alt="wishlist-logo" class="logo-wishlist">
                <label>Operazione a premi - ASPM dà energia alle tue passioni</label>
              </div>
              <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
                <button mat-button color="accent" (click)="downloadPrivacy(2)">
                  Privacy
                  <mat-icon>download</mat-icon>
                </button>
                <button mat-button color="accent" (click)="downloadRegolamento(2)">
                  Regolamento
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </mat-radio-button>
            <mat-radio-button value="3" *ngIf="dataService.user != 2">
              <div fxLayout="row" fxLayoutAlign="start center">
                <img src="../../../assets/imgs/alca.png" alt="alca-logo" class="logo-alca">
                <label>Operazione a premi - ASPM dà energia alle tue passioni</label>
              </div>
              <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column">
                <button mat-button color="accent" (click)="downloadPrivacy(3)">
                  Privacy
                  <mat-icon>download</mat-icon>
                </button>
                <button mat-button color="accent" (click)="downloadRegolamento(3)">
                  Regolamento
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div fxLayout="column" fxFlex="40" fxLayoutGap="20px">
          <div fxLayout="column" class="lista-premi" *ngIf="premiG.value == '0' && !premioConfermatoG">
            <mat-radio-group formControlName="mondadoriG" fxFlexFill>
              <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree" fxFlexFill>
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle fxFlexFill>
                  <li fxFlexFill class="li-tree-node">
                    <mat-card fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutAlign.md="center center" fxLayoutAlign.sm="center center" fxFlexFill>
                      <mat-card-header>
                        <mat-card-title>
                          <mat-radio-button [value]="node.nome">{{node.nome}}</mat-radio-button>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content>
                        <img [src]="node.img" [alt]="node.nome" width="100px" />
                      </mat-card-content>
                    </mat-card>
                  </li>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                  <li class="li-nested-node">
                    <div fxLayoutAlign="start center">
                      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.nome">
                        <mat-icon class="mat-icon-rtl-mirror">
                          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                      </button>
                      {{node.nome}} {{node.id}}
                    </div>
                    <ul [class.tree-invisible]="!treeControl.isExpanded(node)">
                      <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
                  </li>
                </mat-nested-tree-node>
              </mat-tree>
            </mat-radio-group>
          </div>

          <div fxLayout="column" class="lista-premi" *ngIf="premiG.value == '2' && !premioConfermatoG">
            <mat-radio-group fxFlexFill formControlName="wishlistG">
              <mat-tree [dataSource]="dataSourceWish" [treeControl]="treeControlWish" class="example-tree" fxFlexFill>
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle fxFlexFill>
                  <li fxFlexFill class="li-tree-node">
                    <mat-card fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutAlign.md="center center" fxLayoutAlign.sm="center center" fxFlexFill>
                      <mat-card-header>
                        <mat-card-title>
                          <mat-radio-button [value]="node.nome">{{node.nome}}</mat-radio-button>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content>
                        <img [src]="node.img" [alt]="node.nome" width="100px" />
                      </mat-card-content>
                    </mat-card>
                  </li>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                  <li class="li-nested-node">
                    <div fxLayoutAlign="start center">
                      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.nome">
                        <mat-icon class="mat-icon-rtl-mirror">
                          {{treeControlWish.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                      </button>
                      {{node.nome}} {{node.id}}
                    </div>
                    <ul [class.tree-invisible]="!treeControlWish.isExpanded(node)">
                      <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
                  </li>
                </mat-nested-tree-node>
              </mat-tree>
            </mat-radio-group>
          </div>

          <div *ngIf="premiG.value != null && !premioConfermatoG">
            <button [disabled]="setConfermaPremiDisabledG()" color="accent" mat-flat-button (click)="confermaPremioG(true)" fxFlexFill fxLayoutAlign="center center">
              Conferma<mat-icon aria-label="label">done</mat-icon>
            </button>
          </div>

          <div *ngIf="premioConfermatoG && premiG.value != null">
            <button color="accent" mat-flat-button (click)="confermaPremioG(false)" fxFlexFill fxLayoutAlign="center center">
              Modifica<mat-icon aria-label="label">edit</mat-icon>
            </button>
          </div>

          <mat-error *ngIf="premiG.hasError('unchecked')">* Confermare il premio per continuare</mat-error>

        </div>
      </div>
    </ng-container>


    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h3 class="divider-title">
          Modalità consegna del premio
        </h3>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div>
      <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="modoConsegnaPremio">
        <mat-radio-button value="0" [disabled]="disableInvioMail">Ricevi via e-mail all'indirizzo {{mailTo}}</mat-radio-button>
        <ng-container *ngIf="dataService.user != 2">
          <!-- <mat-radio-button value="1" *ngIf="dataService.prodotto?.tipo_utenza == 'BUS'">Ritiro c/o ASPM</mat-radio-button> -->
          <mat-radio-button value="2">Ricevi presso l'indirizzo di residenza</mat-radio-button>
        </ng-container>
        <mat-error *ngIf="datiFirmaForm.get('modoConsegnaPremio')?.hasError('required')">* Selezionare una modalità di invio</mat-error>
      </mat-radio-group>
    </div>

  </ng-container>

  <!-- <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
    <div>
      <h2 class="divider-title">
        Convenzioni
      </h2>
    </div>
    <mat-divider fxFlex="auto"></mat-divider>
  </div>

  <p>Inserire un codice valido o seleziona l’icona delle convenzioni esistenti</p>

  <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
    <mat-form-field>
      <input matInput placeholder="Codice convenzione" formControlName="codicePromo">
      <mat-error *ngIf="datiFirmaForm.get('codicePromo')?.hasError('unchecked')">Confermare il codice per continuare</mat-error>
    </mat-form-field>
    <button color="accent" mat-flat-button (click)="checkConvenzione()" fxLayoutAlign="center center" *ngIf="!datiFirmaForm.get('codicePromo')?.disabled">
      <mat-icon aria-label="label">done</mat-icon>
      Conferma
    </button>
    <button color="accent" mat-flat-button (click)="updateConvenzione()" fxLayoutAlign="center center" *ngIf="datiFirmaForm.get('codicePromo')?.disabled">
      <mat-icon aria-label="label">edit</mat-icon>
      Modifica
    </button>
    <ng-container *ngIf="!premioConfermato && !premioConfermatoG && !['TUTELA', 'VULNERABILI', 'PLACET'].includes(dataService.prodotto!.natura)">
      <div>
        <button fxFlex="none" mat-button color="primary" (click)="setConvenzione('VANOLI')">
          <div fxFlex="none" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" matTooltip='Scegli la convenzione "ASPM tifa Vanoli"' style="padding: 5px;">
            <img src="../../../assets/imgs/logo_vanoli.png" alt="logo-vanoli" style="width: 100px;">
            <span>Promozione - ASPM tifa Vanoli</span>
          </div>
        </button>
      </div>
    </ng-container>

  </div>

  <ng-container *ngIf="dataService.user == 3">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h2 class="divider-title">
          Eventuali sconti
        </h2>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start center">
      <ng-container *ngFor="let select of sconti; index as si" formGroupName="sconti">
        <mat-form-field>
          <mat-select [placeholder]="select['title']" [formControlName]="select['key']">
            <mat-option *ngFor="let item of select['options']" [value]="item.value">
              {{item.label}}
            </mat-option>
          </mat-select>
          <button mat-icon-button matSuffix color="warn" matTooltip="Cancella" (click)="scontiFormGroup.get(select['key'])?.reset(); $event.stopPropagation()"
            [disabled]="scontiFormGroup.get(select['key'])?.disabled">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </ng-container>
    </div>
  </ng-container> -->

  <ng-container *ngIf="dataService.prodotto?.cod_tipo_fornitura_id == 'EE' || dataService.prodotto?.cod_tipo_fornitura_id == 'EE/GAS'">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-checkbox formControlName="energiaVerde" fxLayout="row" fxLayoutAlign="center center" [disabled]="dataService.prodotto?.aumix == 'SI'">
        <span class="disabled-text-energia-verde">
          Energia verde
          <mat-icon class="leaf">spa</mat-icon>
          <span *ngIf="dataService.prodotto?.aumix != 'SI'"> Al costo di €/kWh {{dataService.prodotto?.energia_verde}}</span>
        </span>
      </mat-checkbox>
    </div>
  </ng-container>

  <!-- <ng-container *ngIf="dataService.prodotto?.tipo_utenza == 'DOM'">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h3 class="divider-title" fxLayoutAlign="start center">
          Attivazione turbo <mat-icon color="primary" class="icon-title-bolt">bolt</mat-icon>
        </h3>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-checkbox formControlName="ripensamento" fxLayoutAlign="start start" class="ripensamento-checkbox">
        Il Cliente richiede, ai sensi e per gli effetti dell'art 51 comma 8 del Codice di Consumo, che le procedure per
        l'attivazione della fornitura abbiano inizio anche
        durante il periodo di recesso previsto dall'art. 52 comma 2 del Codice di Consumo.
        Il Cliente rinuncia al periodo di ripensamento e quindi velocizzare l’inizio della fornitura.
      </mat-checkbox>
    </div>
  </ng-container> -->

  <ng-container *ngIf="dataService.user != 2; else datiOtp">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h2 class="divider-title" fxLayoutAlign="start center">
          Modalità di firma <mat-icon color="primary" class="icon-title-drive">drive_file_rename_outline</mat-icon>
        </h2>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>
    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
      <mat-radio-group class="radio-firme" fxLayout="column" fxLayoutGap="10px" formControlName="modalitaFirma">
        <mat-radio-button value="0" disabled>
          <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
            Firma digitale
            <div *ngIf="datiFirmaForm.get('modalitaFirma')?.value == '0'" formGroupName="datiFirmaDigitale" fxLayoutGap="10px">
              <mat-form-field>
                <mat-label>Inserisci e-mail</mat-label>
                <input [required]="setRequired(datiFirmaForm.get('datiFirmaDigitale')?.get('email'))" matInput formControlName="email" oninput="this.value = this.value.toLowerCase()">
                <mat-error *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.hasError('required')">
                  <strong>Campo obbligatorio</strong>
                </mat-error>
              </mat-form-field>
              <div fxFlex="none" fxLayoutGap="5px" formGroupName="telefono">
                <mat-form-field fxFlex="50px">
                  <input [required]="setRequired(datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso'))" matInput placeholder="Prefisso" formControlName="prefisso" maxlength="4">
                  <mat-error *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                  <mat-error
                    *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.hasError('minlength') || datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.hasError('maxlength')">
                    <strong>Lunghezza errata</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="none">
                  <mat-label>Inserisci cellulare</mat-label>
                  <input [required]="setRequired(datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero'))" matInput formControlName="numero" maxlength="10">
                  <mat-error *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                  <mat-error
                    *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.hasError('minlength') || datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.hasError('maxlength')">
                    <strong>Lunghezza errata</strong>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-radio-button>
        <mat-radio-button value="1" disabled>
          <span>Firma grafometrica</span>
        </mat-radio-button>
        <mat-radio-button value="2">Firma cartacea</mat-radio-button>
      </mat-radio-group>
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h3 class="divider-title" fxLayoutAlign="start center">
          Seleziona la sede di firma<mat-icon color="primary" class="icon-title-drive">my_location</mat-icon>
        </h3>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>
    <div fxLayout="column">
      <mat-form-field fxFlex="100">
        <mat-select formControlName="sedeFirma">
          <mat-option *ngFor="let sede of sedi" [value]="sede.value">
            {{sede.label}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="datiFirmaForm.get('sedeFirma')?.value == -1" fxFlexOffset="20px">
        <p>Inserisci l'indirizzo della sede</p>
        <app-indirizzo [indirizzoForm]="indirizzoSedeFirma"></app-indirizzo>
      </div>
    </div> -->
  </ng-container>
  <ng-template #datiOtp>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h3 class="divider-title" fxLayoutAlign="start center" fxLayoutGap="10px">
          <span>Inserire e-mail e telefono per la firma via OTP</span><mat-icon color="primary">draw</mat-icon>
        </h3>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>
    <div formGroupName="datiFirmaDigitale" fxLayoutGap="10px">
      <mat-form-field>
        <mat-label>E-mail</mat-label>
        <input [required]="setRequired(datiFirmaForm.get('datiFirmaDigitale')?.get('email'))" matInput formControlName="email" oninput="this.value = this.value.toLowerCase()">
        <mat-error *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.hasError('required')">
          <strong>Campo obbligatorio</strong>
        </mat-error>
      </mat-form-field>
      <div fxFlex="none" fxLayoutGap="5px" formGroupName="telefono">
        <mat-form-field fxFlex="50px">
          <input [required]="setRequired(datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso'))" matInput placeholder="Prefisso" formControlName="prefisso" maxlength="4">
          <mat-error *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
          <mat-error
            *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.hasError('minlength') || datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('prefisso')?.hasError('maxlength')">
            <strong>Lunghezza errata</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="none">
          <mat-label>Inserisci cellulare</mat-label>
          <input [required]="setRequired(datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero'))" matInput formControlName="numero" maxlength="10">
          <mat-error *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
          <mat-error
            *ngIf="datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.hasError('minlength') || datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.hasError('maxlength')">
            <strong>Lunghezza errata</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </ng-template>

</form>